import { Box, Text } from '@vouched.id/vault';
import React, { useMemo } from 'react';
import { Dropdown } from '../../Dropdown';
import { DropdownItemsSection } from '../../DropdownItemsSection';
import { addIconsToDropdownItems, DropdownItemTypes, DropdownStatusIcon, JobErrorMessage } from '../../utils';
import { SSNCaption } from '../SSNCaption';
import { PrivateSSNRequestDataTable } from './PrivateSSNRequestDataTable';
import { JobType } from 'components/account/jobs/job_type';
import { JobExecutionStatus } from 'models/jobs/shared';
export const PrivateSSNCompletedResult = ({ parentJobStatus, jobStatus, requestData, ssnIsMatch, dobIsMatch }) => {
    const { dropdownHasWarnings, dropdownHasRejections, dropdownItems } = useMemo(() => {
        const dropdownItemsWithoutIcons = [
            {
                text: 'SSN Match',
                type: DropdownItemTypes.BooleanDropdownItem,
                value: ssnIsMatch,
                available: true,
                hasErrorOrWarning: {
                    hasError: !ssnIsMatch,
                    hasWarning: false
                }
            }
        ];
        if (dobIsMatch !== undefined) {
            dropdownItemsWithoutIcons.push({
                text: 'Date of Birth',
                type: DropdownItemTypes.BooleanDropdownItem,
                value: dobIsMatch,
                available: true,
                hasErrorOrWarning: {
                    hasError: !dobIsMatch,
                    hasWarning: false
                }
            });
        }
        return addIconsToDropdownItems(dropdownItemsWithoutIcons);
    }, [ssnIsMatch, dobIsMatch]);
    return (React.createElement(Dropdown, { statusIcon: React.createElement(DropdownStatusIcon, { dropdownHasRejections: dropdownHasRejections, dropdownHasWarnings: dropdownHasWarnings, jobStatus: jobStatus, parentJobStatus: parentJobStatus }), title: "SSN" },
        React.createElement(Box, null,
            React.createElement(SSNCaption, { type: JobType.privateSSN }),
            jobStatus === JobExecutionStatus.Error ? (React.createElement(JobErrorMessage, { typeName: "SSN" })) : (React.createElement(React.Fragment, null,
                React.createElement(DropdownItemsSection, { dropdownItems: dropdownItems }),
                React.createElement(Box, { display: "flex", style: { gap: '15px' } },
                    React.createElement(Text, null, "Source:"),
                    React.createElement(Text, { style: { fontWeight: '600' } }, "Private")),
                requestData && (React.createElement(PrivateSSNRequestDataTable, { requestData: requestData })))))));
};
